export default "__VITE_ASSET__d6e4e845__"